<template>
  <div class="preview-viewer preview-application-viewer">
    <div className="preview-viewer"  v-if="isUnReview">
      <div className="application-view-preview">
        <div className="generate-info">
              <div className="preview-icon">
                  <svg className="type-icon" aria-hidden="true">
                      <use xlinkHref="#icon-preview-error"></use>
                  </svg>
              </div>
              <div className="error-message">
                {{errMsg}}
              </div>
          </div>
      </div>
    </div>
    <iframe v-if="link && !isUnReview" :src="link" id="apllication_frame" name="apllication_frame"></iframe>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import { APP_STORE_ENTER } from '@/config/api'
import config from '@/config'
const loginUser = config.user_info || {}
export default {
  name: 'ApplicationViewer',
  props: {
    item: Object,
    previewInfo: Object,
    name: String,
    kind: String,
    scenario: String
  },
  data () {
    const individualMsg = i18n.t('file.individual.personMsg')
    const individualReviewMsg = i18n.t('file.individual.reviewMsg')
    return {
      timeStamp: +new Date(),
      link: APP_STORE_ENTER,
      errMsg: this.scenario === 'review' ? individualReviewMsg : individualMsg,
      isUnReview: this.scenario === 'review' || (loginUser.id && config.is_personal_account)
    }
  },
  created () {
    this.getApplictionUrl()
    window.addEventListener('message', this.openXmdFile, false)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.openXmdFile, false)
  },
  beforeRouteUpdate (to, from, next) {
    console.log(to)
  },
  methods: {
    openXmdFile (e) {
      const { data } = e
      if (data.type === 'xmd-openNewTab' && data.id) {
        const shareUrl = data.shareUrl
        let path = data.fileType === 'folder' ? '/files/folder/' + data.id : '?preview=1&file_id=' + data.id + '&typed_id=file_' + data.id
        if (shareUrl) {
          window.open(shareUrl)
          return
        }
        this.$router.push({path: path})
      }
    },
    getQuerys (queryArrObj) {
      return (Object.keys(queryArrObj).map(item => `${item}=${queryArrObj[item]}`)).join('&')
    },
    getApplictionUrl (query) {
      let { file_id, review_id, owned_by } = this.previewInfo
      let { scenario } = this._props
      let queryArrObj = {
        name: this.name,
        fileId: file_id,
        isPreview: true,
        enterprise_id: owned_by.enterprise_id
      }
      if (query) {
        queryArrObj.fileId = query.file_id
      }

      let queryParams = encodeURIComponent(this.getQuerys(queryArrObj))

      let drawParams = {
        app_id: config.application_api_id[this.kind || 'ngm'],
        query: queryParams
      }
      if (scenario === 'share') {
        drawParams.scenario = scenario
      }
      if (scenario === 'review') {
        drawParams.from_review_id = review_id
      }
      drawParams = this.getQuerys(drawParams)
      let src = `${config.imageUrl}${APP_STORE_ENTER}?${drawParams}`
      if (this.kind === 'ngm') {
        src = `/micro-app/naotu-web/?${this.getQuerys(queryArrObj)}`
      }
      this.link = src
    }
  }
}
</script>
<style lang="postcss">
  .preview-application-viewer{
    text-align: center;
  }
  .preview-application-viewer {
    & iframe {
      flex: 1 1 auto;
      width: 100%;
      height: 100%;
      border: 0
    }
  }
</style>
